<!-- auth-layout.component.html -->
<div class="auth-layout">
  <router-outlet></router-outlet>
  <!-- Child routes will be rendered here -->
</div>
